import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  EvaluateSupportConversationRequest,
  UpdateAllCommentStatusRequest,
  UpdateAllPostStatusRequest,
  UpdateCommentStatusRequest,
  UpdatePostStatusRequest,
  ViewApprovalCountRequest,
  ViewApprovalMembersRequest,
  ViewApprovalsForUserRequest,
  ViewApprovalsRequest
} from './approval.types';

import {
  requestEvaluateSupportConversation,
  requestUpdateAllCommentStatus,
  requestUpdateAllPostStatus,
  requestUpdateCommentStatus,
  requestUpdatePostStatus,
  requestViewApprovalCount,
  requestViewApprovalMembers,
  requestViewApprovals,
  requestViewApprovalsForUser
} from './approval.actions';

export const useApprovalApi = () => {
  const dispatch = useDispatch();

  const viewApprovalCount = useCallback(
    (requestData: ViewApprovalCountRequest, onSuccess?: () => void) => {
      dispatch(requestViewApprovalCount({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewApprovalMembers = useCallback(
    (requestData: ViewApprovalMembersRequest, onSuccess?: () => void) => {
      dispatch(requestViewApprovalMembers({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewApprovals = useCallback(
    (requestData: ViewApprovalsRequest, onSuccess?: () => void) => {
      dispatch(requestViewApprovals({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updatePostStatus = useCallback(
    (requestData: UpdatePostStatusRequest, onSuccess?: () => void) => {
      dispatch(requestUpdatePostStatus({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateCommentStatus = useCallback(
    (requestData: UpdateCommentStatusRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateCommentStatus({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateAllPostStatus = useCallback(
    (requestData: UpdateAllPostStatusRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateAllPostStatus({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateAllCommentStatus = useCallback(
    (requestData: UpdateAllCommentStatusRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateAllCommentStatus({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewApprovalsForUser = useCallback(
    (requestData: ViewApprovalsForUserRequest, onSuccess?: () => void) => {
      dispatch(requestViewApprovalsForUser({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const evaluateSupportConversation = useCallback(
    (requestData: EvaluateSupportConversationRequest, onSuccess?: () => void) => {
      dispatch(requestEvaluateSupportConversation({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return {
    viewApprovalCount,
    viewApprovalMembers,
    viewApprovals,
    updatePostStatus,
    updateCommentStatus,
    updateAllPostStatus,
    updateAllCommentStatus,
    viewApprovalsForUser,
    evaluateSupportConversation
  };
};
